
import { Routes, Route, Navigate } from 'react-router-dom';
import EntryPages from '../App/EntryPages/EntryPages';
import RouteBuilderComponent from '../App/EntryPages/EntryPage/EntryPageManager';
import DashboardPage from '../App/Dashboard/Dashboard';
import LoginPage from '../App/Login/Login';
import AuthLayout from '../App/Layouts/AuthLayout';
import AdminLayout from '../App/Layouts/AdminLayout';
import MetaTagsManager from '../App/GlobalMetatags/GlobalMetatags';
import LanguageManager from '../App/LanguageManager/LanguageManager';
import BlogTemplateSelector from '../App/BlogsManager/BlogsManager';
import BlogList from '../App/Blogs/BlogList';
import CountryPagesList from '../App/CountryPages/CountryPagesList';
import CountryPagesManager from '../App/CountryPagesManager/CountryPagesManager';
import FeaturedCrossingsManager from '../App/FeaturedCrossings/FeaturedCrossingsManager';
import HomeCityBarManager from '../App/HomeCityBar/HomeCityBarManager';
import HomePagesManager from '../App/HomePages/HomePagesManager';
import MediaKitManager from '../App/MediaKit/MediaKitManager';
import DownloadAppManager from '../App/DownloadApp/DownloadAppManager';

import SitemapHome from '../App/Sitemap/SitemapHome';
import SettingsComponent from '../App/Settings/SettingsComponent';
import BorderStateAdmin from '../App/BorderStates/BorderStates';
import WordCounter from '../App/WordCounter/WordCounter';
import ScheduledPublicationsManager from '../App/ScheduledPublications/ScheduledPublicationsManager';
import CityGeosList from '../App/CityGeos/CityGeosList';
import CityGeoEditor from '../App/CityGeos/CityGeoEditor';
import ReportPointsConfigManager from '../App/ReportPoints/ReportPointsConfigManager';
import MobileUsersList from '../App/MobileUsers/MobileUsersList';
import MobileUserDetail from '../App/MobileUsers/MobileUserDetail';
import AdminUsersManager from '../App/AdminUsers/AdminUsersManager';
import CommunityModerationList from '../App/CommunityModeration/CommunityModerationList';
import CommunityModerationDetail from '../App/CommunityModeration/CommunityModerationDetail';
import CommunityPublish from '../App/CommunityPublish/CommunityPublish';
import PushTest from '../App/PushTest/PushTest';
import CommunityImageFlush from '../App/CommunityImageFlush/CommunityImageFlush';
import AutoAuthorizeRulesManager from '../App/AutoAuthorizeRules/AutoAuthorizeRulesManager';
import WaitTimeOverridesManager from '../App/WaitTimeOverrides/WaitTimeOverridesManager';
import WaitTimesFlushManager from '../App/WaitTimesFlush/WaitTimesFlushManager';
import SocialPrepubsManager from '../App/SocialPrepubs/SocialPrepubsManager';
import WaitPatternsManager from '../App/WaitPatterns/WaitPatternsManager';
import WaitPatternHeatmapManager from '../App/WaitPatterns/WaitPatternHeatmapManager';
import ReelsManager from '../App/Reels/ReelsManager';
import ChatModeration from '../App/ChatModeration/ChatModeration';
import ChatStickers from '../App/ChatStickers/ChatStickers';
import LiveTracksManager from '../App/LiveTracks/LiveTracksManager';
import NewsFeedManager from '../App/NewsFeed/NewsFeedManager';
import AppTermsManager from '../App/AppTerms/AppTermsManager';
import StoriesSettingsManager from '../App/Stories/StoriesSettingsManager';
import StoryReportsManager from '../App/Stories/StoryReportsManager';

export default function AppRoutes() {
    return (
        <Routes>
            <Route element={<AuthLayout />}>
                <Route path="/login" element={<LoginPage />} />
                <Route index element={<LoginPage />} />
            </Route>
            <Route element={<AdminLayout />}>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/entry_pages" element={<EntryPages />} />
                <Route path="/border_states" element={<BorderStateAdmin />} />
                <Route path="/word_counter" element={<WordCounter />} />
                <Route path="/metatags_manager" element={<MetaTagsManager />} />
                <Route path="/lang_manager" element={<LanguageManager />} />
                <Route path="/blogs" element={<BlogList />} />
                <Route path="/blogs/new" element={<BlogTemplateSelector />} />
                <Route path="/blogs/edit/:id" element={<BlogTemplateSelector />} />
                <Route path="/country_pages" element={<CountryPagesList />} />
                <Route path="/country_pages/new" element={<CountryPagesManager />} />
                <Route path="/country_pages/edit/:id" element={<CountryPagesManager />} />
                <Route path="/featured_crossings" element={<FeaturedCrossingsManager />} />
                <Route path="/home_city_bar" element={<HomeCityBarManager />} />
                <Route path="/home_pages" element={<HomePagesManager />} />
                <Route path="/media_kit" element={<MediaKitManager />} />
                <Route path="/download_app" element={<DownloadAppManager />} />
                <Route path="/search_bar" element={<Navigate to="/home_pages" replace />} />
                <Route path="/sitemap" element={<SitemapHome />} />
                <Route path="/scheduled_publications" element={<ScheduledPublicationsManager />} />
                <Route path="/city_geos" element={<CityGeosList />} />
                <Route path="/city_geos/edit/:id" element={<CityGeoEditor />} />
                <Route path="/geofences" element={<Navigate to="/city_geos" replace />} />
                <Route path="/geofences/new" element={<Navigate to="/city_geos" replace />} />
                <Route path="/geofences/edit/:id" element={<Navigate to="/city_geos" replace />} />
                <Route path="/crossing_name_places" element={<Navigate to="/city_geos" replace />} />
                <Route path="/crossing_name_places/new" element={<Navigate to="/city_geos" replace />} />
                <Route path="/crossing_name_places/edit/:id" element={<Navigate to="/city_geos" replace />} />
                <Route path="/report_points" element={<ReportPointsConfigManager />} />
                <Route path="/mobile_users" element={<MobileUsersList />} />
                <Route path="/mobile_users/:id" element={<MobileUserDetail />} />
                <Route path="/settings" element={<StoriesSettingsManager />} />
                <Route path="/stories" element={<Navigate to="/settings" replace />} />
                <Route path="/story_reports" element={<StoryReportsManager />} />
                <Route path="/admin_users" element={<AdminUsersManager />} />
                <Route path="/community_moderation" element={<CommunityModerationList />} />
                <Route path="/community_moderation/:id" element={<CommunityModerationDetail />} />
                <Route path="/community_publish" element={<CommunityPublish />} />
                <Route path="/push_test" element={<PushTest />} />
                <Route path="/chat_moderation" element={<ChatModeration />} />
                <Route path="/chat_stickers" element={<ChatStickers />} />
                <Route path="/live_tracks" element={<LiveTracksManager />} />
                <Route path="/news_feed" element={<NewsFeedManager />} />
                <Route path="/app_terms" element={<AppTermsManager />} />
                <Route path="/community_image_flush" element={<CommunityImageFlush />} />
                <Route path="/auto_authorize_rules" element={<AutoAuthorizeRulesManager />} />
                <Route path="/wait_time_overrides" element={<WaitTimeOverridesManager />} />
                <Route path="/wait_times_flush" element={<WaitTimesFlushManager />} />
                <Route path="/social_prepubs" element={<SocialPrepubsManager />} />
                <Route path="/wait_patterns" element={<WaitPatternsManager />} />
                <Route path="/wait_pattern_heatmap" element={<WaitPatternHeatmapManager />} />
                <Route path="/clips_studio" element={<ReelsManager />} />
                <Route path="/reels" element={<Navigate to="/clips_studio" replace />} />
                <Route path="/cpb_settings" element={<SettingsComponent />} />

                <Route path="/entry_page/new" element={<RouteBuilderComponent />} />
                <Route path="/entry_page/edit/:id" element={<RouteBuilderComponent />} />
            </Route>
        </Routes>
    );
}